let timeDifferenceInMilli = 0;
/**
 * Returns true if the passed in timestamp indicates that an award is expiring soon (or has expired)
 * @param serverTimeString
 * @returns null
 */

export const storeTimeDifference = serverTimeString => {
  const diff = Date.now() - new Date(serverTimeString).getTime();
  timeDifferenceInMilli = Math.abs(diff) > 2000 ? diff : 0;
};
export const getTimeDifference = () => timeDifferenceInMilli;
export const getServerSyncedTime = () => Date.now() - getTimeDifference();